import { render, staticRenderFns } from "./QuoteForm.vue?vue&type=template&id=0bdb6217&scoped=true&"
import script from "./QuoteForm.vue?vue&type=script&lang=js&"
export * from "./QuoteForm.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/projectForm.scss?vue&type=style&index=0&id=0bdb6217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb6217",
  null
  
)

export default component.exports